import {
  useCart,
  useCartCheckout,
  useCartItems,
  useCartTotals,
  useSettings,
} from '@backpackjs/storefront';
import { useEffect, useState } from 'react';
import Button from '../Button/Button';
import { useCartCount } from '../../hooks';

export function CartTotals() {
  const [checkoutDisabled, setCheckoutdisabled] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const cart = useCart();
  const cartItems = useCartItems();
  const cartCount = useCartCount();
  const cartTotals = useCartTotals();
  const { cartCheckout } = useCartCheckout();
  const settings = useSettings();
  const { subtext, subtotalText } = { ...settings?.cart?.totals };

  useEffect(() => {
    if (cartCount === 0) {
      setCheckoutdisabled(true);
    } else {
      setCheckoutdisabled(false);
    }

    if (cart?.discountCodes.length) {
      setDiscountAmount(cartTotals.subtotal - cartTotals.total);
    } else {
      setDiscountAmount(0);
    }
  }, [cart]);

  const [total, setTotal] = useState(0);
  const [subtotal, setSubtotal] = useState(0);

  useEffect(() => {
    setSubtotal(cartTotals?.subtotal || 0);
    setTotal(cartTotals?.total || 0);

    // check for route products in cart
    const routeProducts = cartItems?.filter(
      (item) => item.variant.product.handle === 'routeins'
    );

    // if route products are in cart, decrease total and subtotal by the price of the route products
    if (routeProducts?.length) {
      routeProducts.forEach((routeProduct) => {
        setSubtotal(
          (prevSubtotal) =>
            prevSubtotal -
            parseFloat(
              routeProduct.quantity * routeProduct.variant.priceV2.amount
            )
        );
        setTotal(
          (prevTotal) =>
            prevTotal -
            parseFloat(
              routeProduct.quantity * routeProduct.variant.priceV2.amount
            )
        );
      });
    }
  }, [cartItems, cartTotals]);

  return (
    <div className="flex-col gap-4 border-t border-t-[#DDE2E7] bg-[#ecf7ff]">
      <div className="px-[18px] py-[18px]">
        {cart?.discountCodes.length && discountAmount !== 0 ? (
          <div className="mb-4 flex justify-between">
            <p>Discount</p>
            <p>${parseFloat(discountAmount || '0').toFixed(2)}</p>
          </div>
        ) : null}
        <div className="mb-4 flex justify-between">
          <p className="text-sm font-normal tracking-[.04em]">
            {subtotalText || 'Subtotal'}
          </p>
          <p className="text-sm font-normal">
            <span
              className={`line-through opacity-60 ${
                discountAmount === 0 ? 'hidden' : null
              }`}
            >
              {' '}
              ${parseFloat(subtotal).toFixed(2)}
            </span>{' '}
            ${parseFloat(total).toFixed(2)}
          </p>
        </div>

        {subtext && <p className="mt-1 text-xs">{subtext}</p>}

        <Button
          onClick={cartCheckout}
          variant="filled"
          theme="primary"
          className="w-full lg:pb-[0.85rem] lg:pt-[0.65rem]"
          disabled={checkoutDisabled}
        >
          Checkout
        </Button>

        <p className="mt-2 text-center text-2xs">
          Shipping and taxes are calculated at checkout
        </p>
      </div>
    </div>
  );
}

CartTotals.displayName = 'CartTotals';
